import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AjaxService} from 'AjaxService';
import DataSource from 'devextreme/data/data_source';
import {IAenderungenViewModel} from '@shared/models/aenderungen.model';
import {EntityArt} from '@enums/entityArt.enum';
import {lastValueFrom} from 'rxjs';

export interface IAenderungenSearchRequestViewModel {
  entityArt: EntityArt;
  entityId: number;
  searchText: string;
  skip: number;
  take: number;
  sortColumn: string;
  sortDirection: boolean;
}

interface IAenderungenSearchResponseViewModel {
  items: IAenderungenViewModel[];
  totalItems: number;
}

@Component({
    selector: 'cz-aenderungen',
    templateUrl: './aenderungen.component.html',
    styleUrls: ['./aenderungen.component.css'],
    standalone: false
})
export class AenderungenComponent implements OnChanges {
  dataSource: any = {};
  @Input() entityArt: EntityArt;
  @Input() entityId: number;
  @Input() refresh: object;

  constructor(private ajaxService: AjaxService) {
    const self = this;

    this.dataSource = new DataSource({
      load: function (loadOptions: any) {
        const searchRequest: IAenderungenSearchRequestViewModel = {
          entityArt: EntityArt.TraegerRegister,
          entityId: self.entityId,
          searchText: loadOptions.filter && loadOptions.filter.length > 0 ? loadOptions.filter[0][2] : '',
          skip: loadOptions.skip,
          take: loadOptions.take,
          sortColumn: loadOptions.sort ? loadOptions.sort[0].selector : '',
          sortDirection: loadOptions.sort ? loadOptions.sort[0].desc : false,
        };

        return lastValueFrom(self.ajaxService.post<IAenderungenSearchResponseViewModel>('api/Options/GetAenderungen', searchRequest)).then((response) => {
          return {
            data: response.items,
            totalCount: response.totalItems,
          };
        });
      },
    });
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.filter((item) => item.name === 'searchPanel');

    if (searchPanel && searchPanel[0]) {
      searchPanel[0].location = 'before';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      const change = changes[propName];

      if (propName === 'refresh') {
        this.dataSource.reload();
      }
    }
  }
}
